const ADDITIONAL_INGREDIENT_TYPE = {
  MANUAL: 'MANUAL',
  DEFINITE: 'DEFINITE',
  PROBABLE: 'PROBABLE',
}

export default ADDITIONAL_INGREDIENT_TYPE
